import React from 'react';
// import { LIEN_POSITIONS } from '../../utils/constants'; // Unused import
import './encumbrancebadge.css';

const EncumbranceBadge = ({ 
  lienPosition, 
  encumbrances = [], 
  inUnderwriting = false,
  size = 'medium' 
}) => {
  const getBadgeConfig = () => {
    if (inUnderwriting) {
      return {
        text: 'In Underwriting',
        color: '#F59E0B',
        textColor: '#FFFFFF',
        icon: '⚠'
      };
    }
    
    if (lienPosition === 'Unencumbered') {
      return {
        text: 'Encumbrance: None',
        color: '#22C55E',
        textColor: '#FFFFFF',
        icon: '✓'
      };
    }
    
    if (lienPosition === 'FirstLien') {
      return {
        text: '1st-Lien',
        color: '#22C55E',
        textColor: '#FFFFFF',
        icon: '1'
      };
    }
    
    if (lienPosition === 'SecondLien') {
      return {
        text: '2nd-Lien',
        color: '#F59E0B',
        textColor: '#FFFFFF',
        icon: '2'
      };
    }
    
    return {
      text: 'Encumbered',
      color: '#EF4444',
      textColor: '#FFFFFF',
      icon: '⚠'
    };
  };

  const config = getBadgeConfig();
  const hasMultipleEncumbrances = encumbrances.length > 1;

  return (
    <div
      className={`jo-xyz-demo-encumbrance-badge jo-xyz-demo-encumbrance-badge--${size}`}
      style={{
        backgroundColor: config.color,
        color: config.textColor
      }}
      title={hasMultipleEncumbrances ? `${encumbrances.length} encumbrances` : config.text}
    >
      <div className="jo-xyz-demo-encumbrance-badge__content">
        <span className="jo-xyz-demo-encumbrance-badge__icon">
          {config.icon}
        </span>
        <span className="jo-xyz-demo-encumbrance-badge__text">
          {config.text}
        </span>
        {hasMultipleEncumbrances && (
          <span className="jo-xyz-demo-encumbrance-badge__count">
            +{encumbrances.length - 1}
          </span>
        )}
      </div>
    </div>
  );
};

export default EncumbranceBadge;
